import { useDispatch, useSelector } from "react-redux"
import InputGroup from "react-bootstrap/InputGroup"
import Form from "react-bootstrap/Form"
import { teamStatus } from "state_management"
import useT from "utils/hooks/useT"

export default function IgnoreGreyTasksButton() {
  const { t } = useT("common")
  const dispatch = useDispatch()
  const ignoreGreytasks = useSelector((state) => state.teamStatus.ignoreGreytasks)

  return (
    <InputGroup>
      <Form.Check
        checked={ignoreGreytasks}
        type={"checkbox"}
        id={`iap-ignore-greytasks-checkbox`}
        onChange={(e) => dispatch(teamStatus.ignoreGreytasks({ iapIgnoreWhiteTasks: e.target.checked }))}
      />
      <div className="Include-today">
        <p>{t("ignoreAllGreytasks")}</p>
      </div>
    </InputGroup>
  )
}
